import "./index.css";
import React, { useState } from "react";

const api = {
  key: "16457cb77818d8c8c093aa840a54f602",
  base: "https://api.openweathermap.org/data/2.5/",
};

function App() {
  const [query, setQuery] = useState("");
  const [weather, setWeather] = useState({});
  const [loading, setLoading] = useState(false)
  const search = (evt) => {
    if (evt.key === "Enter") {
      setLoading(true)
      fetch(`${api.base}weather?q=${query}&units=metric&APPID=${api.key}`)
        .then((res) => res.json())
        .then((result) => {
          setWeather(result);
          setQuery("");
          setLoading(false)
        });
    }
  }; 
  const dateBuilder = (d) => {
    let months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    let days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ];

    let day = days[d.getDay()];
    let date = d.getDate();
    let month = months[d.getMonth()];
    return `${day} ${date} ${month}`;
  };

  const isCloudy = weather.clouds ? weather.clouds.all > 5 : false;
  const isRaining = weather.rain ? weather.rain["1h"] > 0 : false;

  const containerClass =
    typeof weather.main === "undefined"
      ? "app"
      : isRaining
      ? "app-wet"
      : isCloudy
      ? "app-cloud"
      : "app";

  const rain = weather.rain
    ? weather.rain["1h"] + '" over the next hour'
    : false;
  return (
    <div className={containerClass}>
      <main>
        <div className="search-box">
          <input
            type="text"
            className="search-bar"
            placeholder="Enter City Name"
            onChange={(e) => setQuery(e.target.value)}
            value={query}
            onKeyPress={search}
          />
        </div>
        {typeof weather.main != "undefined" ? (
          <div>
            <div className="location-box">
              <div className="location">
                {weather.name}, {weather.sys.country}
              </div>
              <div className="date">{dateBuilder(new Date())}</div>
            </div>
            <div className="weather-box">
              <div className="temp">
                {Math.round(weather.main.temp)}ºC
                <br />
                {Math.round((weather.main.temp * 9) / 5) + 32}ºF
               
              </div>
              <div className="weather">{weather.weather[0].main}</div>
              <div className="description">
                {weather.weather[0].description} <br />
                {rain}
                <br/>
                {weather.clouds.all}% cloud coverage
              </div>
            </div>
          </div>
        ) : (
          loading ? 'Loading' : ''
        )}
      </main>
    </div>
  );
}

export default App;
